var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40C31.0459 40 40.0003 31.0457 40.0003 20C40.0003 8.95429 31.0459 -1.52588e-05 20.0002 -1.52588e-05C8.95455 -1.52588e-05 0.000244141 8.95429 0.000244141 20C0.000244141 31.0457 8.95455 40 20.0002 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 20C6.10352e-05 27.5809 4.21795 34.1761 10.4348 37.5682V2.43181C4.21795 5.82392 6.10352e-05 12.4192 6.10352e-05 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 0C16.5353 0 13.2764 0.881485 10.4349 2.4318V37.5681C13.2764 39.1185 16.5353 40 20.0002 40C31.0458 40 40.0002 31.0456 40.0002 20C40.0002 8.95438 31.0458 0 20.0002 0Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5511 23.3076C26.0209 25.1358 22.4876 24.5667 20.6595 22.0366C18.8312 19.5063 19.4004 15.973 21.9306 14.1449C22.7195 13.5749 23.6059 13.238 24.5077 13.1209C22.7728 12.8614 20.9388 13.2523 19.4047 14.3609C16.2906 16.611 15.59 20.9595 17.8401 24.0738C20.0902 27.1877 24.4388 27.8884 27.553 25.638C29.0873 24.5295 30.0343 22.9113 30.3325 21.1825C29.9383 22.0017 29.3401 22.7375 28.5511 23.3076V23.3076Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4427 13.0437L29.868 14.5797L31.7693 13.6991L30.7488 15.5291L32.174 17.0653L30.118 16.6602L29.0976 18.4903L28.8475 16.4099L26.7916 16.0048L28.6929 15.1242L28.4427 13.0437Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakistan);
export default __webpack_public_path__ + "static/media/pakistan.4430bca3bb1da2e65f54dad14a8bb850.svg";
export { ForwardRef as ReactComponent };